type SerializableScalar = string | number | boolean

type SerializableValue =
  | SerializableScalar
  | SerializableScalar[]
  | null
  | undefined

// Axios `paramsSerializer` that serializes arrays as repeated keys (e.g. `eventType=a&eventType=b`) to match Flask's `parse_args(action='append')` convention used by the admin API.
export function queryParamSerializer(
  params: Record<string, SerializableValue>
): string {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) continue
    const values = Array.isArray(value) ? value : [value]
    for (const v of values) search.append(key, String(v))
  }
  return search.toString()
}
